import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { hideModal } from 'state/actions';
import { COLOR, MODAL } from 'config/constants';
import { HvModal, HvButton } from 'components';

const useStyles = makeStyles({
  description: {
    fontSize: 14,
  },
  title: {
    textAlign: 'center',
    fontFamily: 'FordAntenna-Medium',
    marginBottom: 10,
    marginTop: 10,
  },
  cancelButton: {
    backgroundColor: COLOR.WHITE,
    color: COLOR.LIGHT_BLUE,
    border: `1px solid ${COLOR.LIGHT_BLUE}`,
    marginRight: 20,
  },
});

interface Props {
  automatic_saisie: boolean;
  onSave: () => void;
  updateAutomaticSaisie: (value: boolean) => void;
}
function AutoUploadModal({ automatic_saisie, onSave, updateAutomaticSaisie }: Props) {
  const intl = useIntl();
  const styles = useStyles();
  const dispatch = useDispatch();

  const fmtPleaseConfirm = intl.formatMessage({ id: 'profile.pleaseConfirm' });
  const fmtPictureUploadConfirmation = intl.formatMessage({
    id: 'profile.pictureUploadConfirmation',
  });
  const fmtPictureCancelUploadConfirmation = intl.formatMessage({
    id: 'profile.pictureCancelUploadConfirmation',
  });
  const fmtYesConfirm = intl.formatMessage({ id: 'profile.yesConfirm' });
  const fmtYesCancel = intl.formatMessage({ id: 'profile.yesCancel' });
  const fmtCancel = intl.formatMessage({ id: 'cancel' });

  const onClose = () => {
    dispatch(hideModal(MODAL.AUTO_UPLOAD));
  };

  const onCancel = async () => {
    dispatch(hideModal(MODAL.AUTO_UPLOAD));
  };

  const onConfirm = () => {
    updateAutomaticSaisie(!automatic_saisie);
    onSave();
    dispatch(hideModal(MODAL.AUTO_UPLOAD));
  };

  const buttons = (
    <div>
      <HvButton className={styles.cancelButton} onClick={onCancel}>
        {fmtCancel}
      </HvButton>
      <HvButton onClick={onConfirm}>{automatic_saisie ? fmtYesCancel : fmtYesConfirm}</HvButton>
    </div>
  );

  return (
    <HvModal
      title={intl.formatMessage({ id: 'profile.autoUpload' })}
      buttons={buttons}
      onClose={onClose}
    >
      <Typography className={styles.title}>{fmtPleaseConfirm}</Typography>
      <Typography className={styles.description}>
        {automatic_saisie ? fmtPictureCancelUploadConfirmation : fmtPictureUploadConfirmation}
      </Typography>
    </HvModal>
  );
}
export default AutoUploadModal;
